import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    padding: '30px 30px 50px 0px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  totalsBalance: {
    paddingRight: '25px',
  },
});

const InvoiceTotals = ({classes, invoice}) =>
  <div className={classes.root}>
    <div>
      <div className={classes.labelField}>
        <Typography variant="subheading">Subtotal:&nbsp;&nbsp;</Typography>
        <Typography variant="subheading">${invoice.total.toFixed(2)}</Typography>
      </div>
      <div className={classes.labelField}>
        <Typography variant="subheading">GST:&nbsp;&nbsp;</Typography>
        <Typography variant="subheading">${invoice.gst.toFixed(2)}</Typography>
      </div>
      <div className={classes.labelField}>
        <Typography variant="subheading">PST:&nbsp;&nbsp;</Typography>
        <Typography variant="subheading">${invoice.pst.toFixed(2)}</Typography>
      </div>
      <hr />
      <div className={classes.labelField}>
        <Typography className={classes.totalsBalance} variant="subheading">Total:</Typography>
        <Typography variant="subheading">${invoice.grandTotal.toFixed(2)}</Typography>
      </div>
      <div className={classes.labelField}>
        <Typography className={classes.totalsBalance} variant="subheading">Payments:</Typography>
        <Typography variant="subheading">${invoice.paymentTotal.toFixed(2)}</Typography>
      </div>
      <hr />
      <hr />
      <div className={classes.labelField}>
        <Typography className={classes.totalsBalance} variant="title">Balance:</Typography>
        <Typography variant="title">${invoice.balance.toFixed(2)}</Typography>
      </div>
    </div>
  </div>

  export default withStyles(styles)(InvoiceTotals);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/Preview/InvoiceTotals.jsx